module.exports = __webpack_public_path__ + "img/logo-2.080a1f3f.png";